function TokenStorage(eventKey = null) {
    const KEY_CLIENT_ACCESS_TOKEN = 'client_access_token';
    const tokenListeners = [];

    this.getStorageKey = () => null === eventKey ? null : `${KEY_CLIENT_ACCESS_TOKEN}_${eventKey}`;

    this.set = (token) => {
        if (!eventKey) {
            return;
        }

        if (!token || '~' === token) {
            localStorage.removeItem(this.getStorageKey());
            tokenListeners.forEach((listener) => listener(null))

            return;
        }

        localStorage.setItem(this.getStorageKey(), token);
        tokenListeners.forEach((listener) => listener(token))
    };

    this.get = () => {
        if (!eventKey) {
            return null;
        }

        return localStorage.getItem(this.getStorageKey()) || null;
    };

    this.addEventListener = (listener) => {
        tokenListeners.push(listener);
    };

    this.removeEventListener = (listener) => {
        const index = tokenListeners.findIndex((_listener) => _listener === listener);
        if (-1 === index) {
            return;
        }
        tokenListeners.splice(index, 1);
    };

    this.setEventKey = (key) => {
        eventKey = key;
    };

    this.getEventKey = () => eventKey;

    window.addEventListener('storage', (e) => {
        if (e.key !== this.getStorageKey()) {
            return;
        }

        const token = localStorage.getItem(this.getStorageKey()) || null;
        tokenListeners.forEach((listener) => listener(token));
    });
}

export default new TokenStorage();
